import FullPageLoading from './fullPageLoading';

export default FullPageLoading;
